import React, { useState, useEffect } from 'react'
import { useSearchParams} from "react-router-dom";

import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { Grid, Typography, Button } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import DeleteNotification from '../../core/components/DeleteNotification';
import {CoreContext} from "../../core/context/CoreContext";
import PageWaiting from '../../core/components/PageWaiting';
import {isMobile} from 'react-device-detect';

import {getListAPI, deleteAPI} from './ProductAPI';
import {getColumns} from './ProductStruct';
import ListCardView from '../../core/components/card/ListCardView';
import ListTableView from '../../core/components/card/ListTableView';

import {getProductView} from './ProductView';
import CardListLayout from '../../core/components/card/layout/CardListLayout';
import { useSelector, useDispatch } from 'react-redux';
import {setViewParams} from '../../store/slice/ChoiceSelectionSlice';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';

import {setFilter} from '../../store/slice/ConfSlice';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import MyPageContainer from '../../core/template/MyPageContainer';
import { deleteProductObj  ,setSelectedProductId,setProductManagecompositionModal,setProductEditproductModal,setProductViewproductModal,setProductDeleteproductModal,setProductUpdateproductstatusModal,setProductUpdateproductModal,setProductUploaddesignModal,setProductRmmanagementModal,setProductQaapprovalModal,setProductDesignPrintingModal,setSelectedActionId , setShowEditForProduct, setSelectedCompositiontemplateId} from 'store/slice/PharmaSlice';

import ProductListTable from './components/ProductListTable';
import { useNavigate } from "react-router-dom";
import { setClickedBo,setActionClicked } from 'store/slice/BreadCrumSlice';
import ModeEditIcon from '@mui/icons-material/ModeEdit';

import SettingsInputCompositeIcon from '@mui/icons-material/SettingsInputComposite';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import PolylineIcon from '@mui/icons-material/Polyline';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';

import ManagecompositionActionModal from './action/managecomposition/ManagecompositionActionModal';
import EditproductActionModal from './action/editproduct/EditproductActionModal';
import ViewproductActionModal from './action/viewproduct/ViewproductActionModal';
import DeleteproductActionModal from './action/deleteproduct/DeleteproductActionModal';
import UpdateproductstatusActionModal from './action/updateproductstatus/UpdateproductstatusActionModal';
import UpdateproductActionModal from './action/updateproduct/UpdateproductActionModal';
import UploaddesignActionModal from './action/uploaddesign/UploaddesignActionModal';
import RmmanagementActionModal from './action/rmmanagement/RmmanagementActionModal';
import QaapprovalActionModal from './action/qaapproval/QaapprovalActionModal';
import DesignPrintingActionModal from './action/designPrinting/DesignPrintingActionModal';

import { transformDateValue } from 'core/js/FormUtils';
import { setSelectedCTid } from 'store/slice/AppSlice';

export default function ProductListImpl( {tableList, cardList, setShowEdit, setProductId}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setNotification, setShowLoading, showloading, lastURL } = React.useContext(CoreContext);
  const columns = getColumns(editCallBack, initDeleteCallBack);
  const [view, setView] = useState(1);
  const { showfilter } = useSelector((state) => state.confslice)

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const {selectedId, productObj} = useSelector((state)=>state.pharmaslice.productDashboard);
  const { productList } = useSelector((state) => state.pharmaslice.productDashboard);
  const {pharmaorderDashboard} = useSelector((state)=>state.pharmaslice);

  useEffect(() => {
  }, [productList, productObj])
  
  function initDeleteCallBack(id){
    dispatch(setSelectedProductId(id));
    setShowDeleteAlert(true);
  }
  function deleteCallBack(obj){
    dispatch(deleteProductObj(obj.id));
    setNotification('Record deleted successfully !!!')
  }
  function deleteRecord(){
    deleteAPI(selectedId,deleteCallBack);
    setShowDeleteAlert(false);
  }

  function editCallBack(id){
    dispatch(setSelectedProductId(id));
    dispatch(setShowEditForProduct(true));
  }
  
  const createProduct=()=>{
    dispatch(setSelectedCTid(''));
    dispatch(setSelectedProductId(-1));
    dispatch(setSelectedCompositiontemplateId(-1));
   // dispatch(setShowEditForProduct(true));
    dispatch(setProductUpdateproductModal(true));
  }


  const managecompositionCallBack = (id) =>{
    dispatch(setSelectedProductId(id));
    dispatch(setProductManagecompositionModal(true));
  }
  const editproductCallBack = (id) =>{
    dispatch(setSelectedProductId(id));
    dispatch(setProductEditproductModal(true));
  }
  const viewproductCallBack = (id) =>{
    dispatch(setSelectedProductId(id));
    dispatch(setProductViewproductModal(true));
  }
  const deleteproductCallBack = (id) =>{
    dispatch(setSelectedProductId(id));
    dispatch(setProductDeleteproductModal(true));
  }
  const updateproductstatusCallBack = (id) =>{
    dispatch(setSelectedProductId(id));
    dispatch(setProductUpdateproductstatusModal(true));
  }
  const updateproductCallBack = (id) =>{
    dispatch(setSelectedProductId(id));
    dispatch(setProductUpdateproductModal(true));
  }
  const uploaddesignCallBack = (id) =>{
    dispatch(setSelectedProductId(id));
    dispatch(setProductUploaddesignModal(true));
  }
  const rmmanagementCallBack = (id) =>{
    dispatch(setSelectedProductId(id));
    dispatch(setProductRmmanagementModal(true));
  }
  const qaapprovalCallBack = (id) =>{
    dispatch(setSelectedProductId(id));
    dispatch(setProductQaapprovalModal(true));
  }
  const designPrintingCallBack = (id) =>{
    dispatch(setSelectedProductId(id));
    dispatch(setProductDesignPrintingModal(true));
  }

const getDataWithDateTransformation = (data) =>{
    let newData = {
      ...data,
      'expand':false,
		'expirydate': transformDateValue(data.expirydate),
		'podate': transformDateValue(data.podate),
		'dispatchdate': transformDateValue(data.dispatchdate),
		'designdispatched': transformDateValue(data.designdispatched),
		'rmorderedon': transformDateValue(data.rmorderedon),
		'rmreceivedon': transformDateValue(data.rmreceivedon),
		'designorderedon': transformDateValue(data.designorderedon),
		'designreceivedon': transformDateValue(data.designreceivedon)
    }
    return newData;
  }
  const productTransformation = (tableList) =>{
    let newDataList=[]
    tableList.map((data)=>{ 
      newDataList.push(getDataWithDateTransformation(data));
     })
    return newDataList;
  }

  const payload = {
    productList:productList,
    cardList:getProductView(tableList),
        actionList: [
          /*{title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
          {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
          
        {id:9, title:'Manage Composition', callBackMethod:managecompositionCallBack, icon:<SettingsInputCompositeIcon/>, status:'Draft, REFERED BACK', role:'PHARMA_OMS_SALES, PHARMA_OMS_MANAGER'},
        {id:10, title:'Edit Product', callBackMethod:editproductCallBack, icon:<DriveFileRenameOutlineIcon/>, status:'Draft, REFERED BACK', role:'PHARMA_OMS_SALES, PHARMA_OMS_MANAGER'},
        {id:11, title:'View Product', callBackMethod:viewproductCallBack, icon:<RemoveRedEyeIcon/>, status:'NA', role:''},
        {id:19, title:'Delete Product', callBackMethod:deleteproductCallBack, icon:<DeleteSweepIcon/>, status:'Draft', role:''},
        {id:28, title:'Update Product Status', callBackMethod:updateproductstatusCallBack, icon:<DynamicFeedIcon/>, status:'NA', role:''},
        {id:29, title:'Update Product', callBackMethod:updateproductCallBack, icon:<DesignServicesIcon/>, status:'NA', role:''},
        {id:38, title:'Upload Design', callBackMethod:uploaddesignCallBack, icon:<AddPhotoAlternateIcon/>, status:'designing, design approval', role:'PHARMA_OMS_DESIGNER,PHARMA_OMS_MANAGER'},
        {id:40, title:'RM Management', callBackMethod:rmmanagementCallBack, icon:<PolylineIcon/>, status:'designing, design approval, planning, design printing', role:'PHARMA_OMS_RM,PHARMA_OMS_MANAGER'},
        {id:46, title:'QA Approval', callBackMethod:qaapprovalCallBack, icon:<SpellcheckIcon/>, status:'designing', role:'PHARMA_OMS_QA'},
        {id:48, title:'Printing Mgmt', callBackMethod:designPrintingCallBack, icon:<LocalPrintshopIcon/>, status:'design printing', role:'PHARMA_OMS_DESIGNER'},
        */
        ],
        dialogueActionList: [
          
        ],
    tableView:{
      tableList:productTransformation(tableList),
      productList:productList,
      actionList:[
        // {title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'Draft'},
        // {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
        
        //{id:9, title:'Manage Composition', callBackMethod:managecompositionCallBack, icon:<SettingsInputCompositeIcon/>, status:'Draft, REFERED BACK', role:'PHARMA_OMS_SALES, PHARMA_OMS_MANAGER'},
        //{id:10, title:'Edit Product', callBackMethod:editproductCallBack, icon:<DriveFileRenameOutlineIcon/>, status:'Draft, REFERED BACK', role:'PHARMA_OMS_SALES, PHARMA_OMS_MANAGER'},
        {id:11, title:'View Product', callBackMethod:viewproductCallBack, icon:<RemoveRedEyeIcon/>, status:'NA', role:''},
        {id:19, title:'Delete Product', callBackMethod:deleteproductCallBack, icon:<DeleteSweepIcon/>, status:'Draft', role:''},
        // {id:28, title:'Update Product Status', callBackMethod:updateproductstatusCallBack, icon:<DynamicFeedIcon/>, status:'NA', role:''},
        {id:29, title:'Update Product', callBackMethod:updateproductCallBack, icon:<ModeEditIcon/>, status:'Draft, REFERRED BACK', role:''},
        {id:38, title:'Upload Design', callBackMethod:uploaddesignCallBack, icon:<AddPhotoAlternateIcon/>, status:'designing, design approval, planning', role:'PHARMA_OMS_DESIGNER,PHARMA_OMS_MANAGER'},
        {id:40, title:'RM Management', callBackMethod:rmmanagementCallBack, icon:<PolylineIcon/>, status:'designing, design approval, planning, design printing', role:'PHARMA_OMS_RM,PHARMA_OMS_MANAGER'},
        {id:46, title:'QA Approval', callBackMethod:qaapprovalCallBack, icon:<SpellcheckIcon/>, status:'designing', role:'PHARMA_OMS_QA'},
        {id:48, title:'Printing Mgmt', callBackMethod:designPrintingCallBack, icon:<LocalPrintshopIcon/>, status:'design printing', role:'PHARMA_OMS_DESIGNER'},
      ]
    }
  }
  
  const getPayload = ()=>{
    return payload;
  }

  useEffect(()=>{
    if (document.body.offsetWidth<500)  setView(0);
    dispatch(setViewParams({
      colsCount:{xs:12, sm:4, md:4, lg:4},
      modal:{
            
      }
      }))
  },[])

  return (
   <>
   {showloading?<PageWaiting/>:
      <Grid container direction="column"  padding={1} sx={{border: '1px solid #ccc', borderRadius: 2, backgroundColor: 'secondary.lighter'}}>
              <Grid item sx={{paddingBottom:1}}>
                  <Grid container direction="row" justifyContent={'space-between'} alignContent={'center'}>
                      <Grid item>
                        <Typography variant='h4'>Product List</Typography>
                      </Grid>
                      {pharmaorderDashboard.selectedId!==-1?
                      <Grid item>
                        <Grid container justifyContent={'flex-end'} spacing={1}>
                        {/* {showfilter?
                            <Grid item>
                              <Tooltip title="Hide filter" sx={{cursor: "pointer"}}>
                                <FilterAltOffIcon onClick={()=>{dispatch(setFilter(false))}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Show filter" sx={{cursor: "pointer"}}>
                                <FilterAltIcon onClick={()=>{dispatch(setFilter(true))}}/>
                              </Tooltip>
                            </Grid>
                            {view===1?
                            <Grid item>
                              <Tooltip title="Grid View" sx={{cursor: "pointer"}}>
                                <ViewWeekIcon onClick={()=>{setView(0)}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Table View" sx={{cursor: "pointer"}}>
                                <CalendarViewMonthIcon onClick={()=>{setView(1)}}/>
                              </Tooltip>
                            </Grid>
                            } */}
                            <Grid item>
                              <Tooltip title="Add Product" sx={{cursor: "pointer"}}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  startIcon={<AddIcon />}
                                  onClick={() => { createProduct(); }}
                                  sx={{ minWidth: 0, padding: '6px 12px' }}
                                >
                                  Add Product
                                </Button>
                              </Tooltip>
                            </Grid>
                          </Grid>
                      </Grid>
                      :<></>}
                      
                  </Grid>
              </Grid>
              <Grid item>
                  
                      < ProductListTable 
                        payload={getPayload().tableView}
                        />
                    
              </Grid>     
      </Grid>
   }
    { showDeleteAlert?<DeleteNotification 
            id={selectedId}
            width="50%"
            setShowDeleteAlert={setShowDeleteAlert}
            deleteRecord = {deleteRecord}/>: ''
    }

    
<ManagecompositionActionModal/>
<EditproductActionModal/>
<ViewproductActionModal/>
<DeleteproductActionModal/>
<UpdateproductstatusActionModal/>
<UpdateproductActionModal/>
<UploaddesignActionModal/>
<RmmanagementActionModal/>
<QaapprovalActionModal/>
<DesignPrintingActionModal/>
    </>
);


}